export enum PageListType {
  ATOZ = 'atoz',
  TEASER = 'teaser',
  TABLE = 'table',
}

export enum PageListDisplayedInformationType {
  teaserText = 'teaserText',
  teaserTextFallbackHeader = 'teaserTextFallbackHeader',
  header = 'header',
  headerFallbackTeaserText = 'headerFallbackTeaserText',
}

export function getDisplayedTextByConfig<T extends { teaserText?: string; header?: string }>(
  item: T,
  displayedInformationType?: PageListDisplayedInformationType,
) {
  switch (true) {
    case displayedInformationType === PageListDisplayedInformationType.teaserText:
      return item.teaserText || undefined;
    case displayedInformationType === PageListDisplayedInformationType.header:
      return item.header || undefined;
    case displayedInformationType === PageListDisplayedInformationType.headerFallbackTeaserText:
      return item.header || item.teaserText || undefined;
    case displayedInformationType === PageListDisplayedInformationType.teaserTextFallbackHeader:
    default:
      return item.teaserText || item.header || undefined;
  }
}
